import { render, staticRenderFns } from "./FormulateVSelect.vue?vue&type=template&id=824c68e2"
import script from "./FormulateVSelect.vue?vue&type=script&lang=js"
export * from "./FormulateVSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports